import PropTypes from 'prop-types'
import styles from './Pane.module.css'

const SHADOWS = ['none', 'low', 'mid', 'high']

export function Pane({ shadow = 'none', className = '', children }) {
  const classes = [styles.pane, shadow !== 'none' ? styles[`pane--shadow-${shadow}`] : '', className]
    .filter(Boolean)
    .join(' ')

  return <div className={classes}>{children}</div>
}

Pane.propTypes = {
  shadow: PropTypes.oneOf(SHADOWS),
  className: PropTypes.string,
  children: PropTypes.node,
}
